<template>
  <SearchResultCard
    v-bind="cardItem"
    :layout="currentLayout"
    @click.native="goToItem"
    :highlight="highlight"
    :href="href"
  >
    <template #no-thumb>
      <span class="no-thumb">
        <span class="svg-container">
          <inline-svg
            :src="require('@assets/eyecon.svg')"
            :title="item.title"
          />
        </span>
      </span>
    </template>
  </SearchResultCard>
</template>

<script>
import { SearchResultCard } from '@web-nfb/vue-3-components'
import { mapGetters } from 'vuex'
import { secondsToDuration, durationToString } from '@helpers/duration'
import { getRouteDataForWorkItem } from '@helpers/router'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'ResultCard',
  components: {
    SearchResultCard,
    InlineSvg
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    thumbPattern: {
      type: String,
      default: null
    },
    highlight: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      locale: 'Global/locale',
      currentLayout: 'ResultOptions/currentLayout'
    }),
    cardItem () {
      const bind = {
        title: this.item.title,
        subtitle: this.subtitle,
        legendList: this.legendList,
        description: this.description
      }

      if (this.routerLink) {
        bind.routerLink = this.routerLink
      }

      if (this.item.thumbnail && this.thumbPattern) {
        bind.thumbPath = this.item.thumbnail
        bind.thumbPattern = this.thumbPattern
        bind.thumbHeight = ''
      }

      return bind
    },
    subtitle () {
      if (!this.item.directors || this.item.directors.length === 0) {
        return ''
      }

      return this.item.directors.map(director => `${director.first_name} ${director.last_name}`).join(', ')
    },
    legendList () {
      const items = []

      if (this.category) {
        items.push({ html: this.$t(`category.${this.category}`) })
      }

      if (this.item.year) {
        items.push({ html: this.item.year })
      }

      if (this.duration) {
        if (this.category === 'interactive') {
          items.push({ html: this.durationStringInteractive })
        } else {
          items.push({ html: this.durationString })
        }
      }
      if (this.item.cc) {
        items.push({ html: `<i class="icon-cc-${this.locale}-o"></i>` })
      }
      if (this.item.dv) {
        items.push({ html: '<i class="icon-dv-o"></i>' })
      }

      return items
    },
    routerLink () {
      return getRouteDataForWorkItem(this.item, this.locale)
    },
    durationString () {
      return durationToString(this.duration)
    },
    duration () {
      return secondsToDuration(this.item.duration)
    },
    durationStringInteractive () {
      return `~ ${durationToString(this.duration)}`
    },
    layout () {
      return this.$parent?.layout ?? false
    },
    category () {
      return this.item.category
    },
    description () {
      // strip item description from potential HTML tags
      return this.item.description?.replace(/(<([^>]+)>)/gi, '')
    },
    href () {
      return this.routerLink && this.$router.resolve(this.routerLink).path
    }
  },
  methods: {
    goToItem () {
      if (this.$route.path !== this.href) {
        this.$router.push(this.routerLink)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import (reference) "~@less/shared/utilities.less";
.no-thumb {
  display: block;
  background: @grey-100;
  position: relative;
  height: 0;
  padding-top: 192/341*100%;

  .svg-container {
    display: block;
    width: 50%;
    position: absolute;
    bottom: -8px;
    right: 20px;
    fill: @white;

    svg {
      max-width: 100%;
    }
  }
}
</style>
